import React from 'react';

function ViewMembershipService({ service, closeModal }) {
    if (!service) return null;

    function formatDateTime(isoString) {
        if (!isoString) return '-';
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    return (
        <div className="modal fade viewbox edit-box show d-block">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Membership Service Details</h5>
                        <button type="button" className="btn-close" onClick={closeModal}></button>
                    </div>

                    <div className="modal-body px-5">
                        <div className="d-box mt-3 pt-1">
                            <ul className="list-unstyled">

                                <li><strong>Membership Name:</strong> {service?.membershipId?.name}</li>
                                <li><strong>Price:</strong> {service?.membershipId?.price}</li>
                                <li><strong>Duration Days:</strong> {service?.membershipId?.durationDays}</li>

                                <li><strong>Membership Max Orders:</strong> {service?.membershipId?.benefits?.maxOrdersPerDay}</li>
                                <li><strong>Membership Max Discount:</strong> {service?.membershipId?.benefits?.maxDiscountPerOrder}</li>
                                <li><strong>Membership Discount %:</strong> {service?.membershipId?.benefits?.discountPercent}</li>

                                <hr />

                                <li><strong>Service Title:</strong> {service?.serviceId?.title}</li>
                                <li><strong>Service Description:</strong> {service?.serviceId?.description}</li>
                                <li><strong>Service City:</strong> {service?.serviceId?.cityName}</li>
                                <li><strong>Service Address:</strong> {service?.serviceId?.address}</li>

                                <hr />

                                <li><strong>Service Max Orders Per Day:</strong> {service?.rules?.maxOrdersPerDay}</li>
                                <li><strong>Service Max Discount Per Order:</strong> {service?.rules?.maxDiscountPerOrder}</li>
                                <li><strong>Service Discount %:</strong> {service?.rules?.discountPercent}</li>

                                <hr />

                                <li><strong>Status:</strong> {service?.isActive ? 'Active' : 'Inactive'}</li>
                                <li><strong>Created Date:</strong> {formatDateTime(service?.createdAt)}</li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewMembershipService;